<style scoped>
.tracking-bullet {
  position: absolute;
  background-color: #999999;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  z-index: 10;
  display: flex;
}

.tracking-bullet svg {
  margin: auto;
}

.finished .tracking-bullet {
  background-color: #007bff;
}

.active .tracking-bullet::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  background-color: #34ff26;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  z-index: 100;
}

.tracking-container:not(:last-child) .tracking-item::after {
  content: '';
  position: absolute;
  left: 0px;
  top: 0px;
  border-left: 6px solid #999999;
  height: calc(100% + 1rem);
  z-index: 0;
}

.tracking-container.finished .tracking-item::after {
  border-left: 6px solid #007bff;
  margin-top: 5px;
}

.tracking-container.active .tracking-item::after {
  border-left: 6px solid #999999;
}

.tracking-item {
  position: relative;
  margin-left: 12px;
  padding-left: 24px;
  min-height: 100px;
}

.tracking-item p {
  color: #999999;
}

.finished .tracking-item p {
  color: #555555;
}

.last-tracking-item {
  margin-left: 12px;
  padding-left: 26px;
}

.tracking-title {
  margin: 0px;
  font-weight: bold;
  font-size: large;
}

:deep(ol) {
  list-style-type: decimal;
}

:deep(ul) {
  list-style-type: disc;
}

:deep(ul),
:deep(ol) {
  padding-inline-start: 30px;
}
</style>

<template>
  <div>
    <nav-bar />

    <div class="main">
      <page-header
        title="Tracking Permohonan"
        subtitle="Silahkan gunakan nomor permohonan dari OSS untuk mencari permohonan Anda"
      />
      <section class="review-section ptb-100">
        <div class="container">
          <div class="d-flex mb-5">
            <div>
              <select
                id="jenis_permohonan"
                v-model="jenis_permohonan"
                class="form-control"
              >
                <option value="Berusaha">Berusaha</option>
                <option value="Non Berusaha">Non Berusaha</option>
                <option value="Penambahan KBLI">Penambahan KBLI</option>
                <option value="Notifikasi Izin Lokasi">
                  Notifikasi Izin Lokasi
                </option>
              </select>
            </div>
            <div class="d-flex flex-grow-1 ml-2">
              <input
                id="no_permohonan"
                v-model="no_permohonan"
                type="text"
                class="form-control"
                placeholder="Contoh: I-123456/20.XX.X"
              />
              <button
                style="width: 200px"
                type="button"
                class="btn btn-primary ml-2 text-nowrap"
                @click="getTracking"
              >
                Cari Permohonan
              </button>
            </div>
          </div>
          <div v-if="is_loading">
            <div class="spinner-border">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <template v-if="is_exist === true">
            <div v-if="status_verdok && status_verdok !== 'Dokumen Lengkap'">
              <div class="card">
                <div class="card-body">
                  <h5>
                    <u>Status Verifikasi Dokumen: {{ status_verdok }}</u>
                  </h5>
                  <template v-if="catatan_verdok">
                    <h6>Catatan:</h6>
                    <div v-html="catatan_verdok"></div>
                  </template>
                </div>
              </div>
            </div>
            <div v-else-if="hasil_vertek && hasil_vertek === 'Ditolak'">
              <div class="card">
                <div class="card-body">
                  <h5>
                    <u>Hasil Penilaian Teknis: {{ hasil_vertek }}</u>
                  </h5>
                  <template v-if="alasan_penolakan">
                    <h6>Alasan Penolakan:</h6>
                    <div v-html="alasan_penolakan"></div>
                  </template>
                </div>
              </div>
            </div>
            <div v-else>
              <div
                v-for="(data, index) in dataTracking"
                :key="index"
                :class="[
                  'tracking-container',
                  {
                    active: data.active && index + 1 !== dataTracking.length,
                    finished: data.accomplished
                  }
                ]"
              >
                <div class="position-relative">
                  <div class="tracking-bullet">
                    <svg
                      v-if="
                        index + 1 !== dataTracking.length
                          ? data.accomplished && !data.active
                          : data.accomplished
                      "
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.5 10.75L8.5 16.75L17.5 3.25"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="tracking-item">
                    <p class="tracking-title">
                      {{ data.status }}
                    </p>
                    <small
                      v-if="data.catatan"
                      class="text-danger"
                    >
                      <div v-html="data.catatan"></div>
                    </small>
                    <p v-if="data.timeStamp">
                      {{ formatDate(data.timeStamp, 'HH:mm, DD MMMM YYYY') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div v-if="is_exist === false">Nomor permohonan tidak ditemukan</div>
          <div
            v-if="is_error"
            class="text-danger"
          >
            Terjadi kesalahan saat mengambil data
          </div>
        </div>
      </section>
    </div>
    <site-footer :show-subscribe="true" />
    <copyright />
  </div>
</template>

<script>
import NavBar from '../views/commons/NavBar'
import PageHeader from '../views/commons/PageHeader'
import SiteFooter from '../views/commons/SiteFooter'
import Copyright from '../views/commons/Copyright'
import DOMPurify from 'dompurify'

import dayjs from 'dayjs'
import 'dayjs/locale/id'

export default {
  name: 'GalleryPage',
  components: {
    SiteFooter,
    PageHeader,
    NavBar,
    Copyright
  },
  data() {
    return {
      apiEsea: 'https://be.sea-v3.mysurvey.id/api',
      // apiEsea: 'https://backend-sea.kkp.go.id/api',
      jenis_permohonan: 'Berusaha',
      no_permohonan: '',
      is_exist: null,
      is_error: false,
      is_loading: false,
      dataTracking: [],
      status_verdok: null,
      catatan_verdok: null,
      hasil_vertek: null,
      alasan_penolakan: null
    }
  },
  methods: {
    dayjs,
    formatDate(date, format) {
      return dayjs(date).locale('id').format(format)
    },

    async getTracking() {
      this.is_exist = null
      this.is_error = false
      this.is_loading = true
      this.status_verdok = null
      this.catatan_verdok = null
      this.hasil_vertek = null
      this.alasan_penolakan = null

      const _no_permohonan = this.no_permohonan.replace(/\s+/g, '')
      this.no_permohonan = _no_permohonan
      try {
        const resTracking = await this.$axios.get(
          `${this.apiEsea}/dashboard/trackingStatusPermohonan?jenis_permohonan=${this.jenis_permohonan}&no_permohonan=${_no_permohonan}`
        )
        this.is_exist = true

        const activeIndex = resTracking.data.data.findLastIndex(
          (d) => d.accomplished
        )
        this.dataTracking = resTracking.data.data
          .filter(
            (d) =>
              d.status !== 'Sudah Paraf Pengesahan KKPRL oleh Kepala Biro Hukum'
          )
          .map((d, i) => {
            const status = d.status.includes('Sudah Paraf Pengesahan KKPRL')
              ? 'Sudah Paraf Pengesahan KKPRL'
              : d.status
            return {
              ...d,
              status,
              active: activeIndex === i,
              catatan: DOMPurify.sanitize(d.catatan)
            }
          })

        const lastItem = this.dataTracking.slice(-1)[0]
        const { additional } = lastItem
        if (additional) {
          this.status_verdok = additional.status_verdok
          this.catatan_verdok = DOMPurify.sanitize(additional.catatan_verdok)
          this.hasil_vertek = additional.hasil_vertek
          this.alasan_penolakan = DOMPurify.sanitize(
            additional.alasan_penolakan
          )
        }
      } catch (error) {
        if (error.response.status < 500) {
          this.is_exist = false
        } else {
          this.is_error = true
        }
      } finally {
        this.is_loading = false
      }
    }
  }
}
</script>
